/**************************************************
 * Nombre:       Tarjeta_Comunidad
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {NEGRITA} from "../../Constantes";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Comunidad = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.primary.main,
                py: 3,
                px: 3,
                color: '#fff'
            }}
        >

            <Grid container size={{xs: 2, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{fontFamily: NEGRITA, fontSize: sCell ? 32 : 40, lineHeight: 1.1}}>{item.numero}</Typography>
            </Grid>


            <Grid container size={{xs: 9, sm: 12, md: 9}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontFamily: NEGRITA, fontSize: sCell ? 32 : 40, lineHeight: 1.1}}>
                    {item.nombre}
                </Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Comunidad